import { Component } from "react";
import PropTypes from "prop-types";

import { ErrorHandlingContext } from "./ErrorHandlingProvider";

const noop = () => {};
const createMessage = (label, errorMessage) =>
  [label, errorMessage].filter(Boolean).join("__");

class ErrorBoundary extends Component {
  static get contextType() {
    return ErrorHandlingContext;
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.restore = () => this.setState({ hasError: false });
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const errorHandler = this.context;
    errorHandler.dispatchRenderError(
      error,
      createMessage(this.props.label, error.message),
    );
  }

  componentDidMount() {
    this.props.onRestore(this.restore);
  }

  componentWillUnmount() {
    this.props.stopOnRestore();
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  label: PropTypes.string,
  fallback: PropTypes.node,
  onRestore: PropTypes.func,
  stopOnRestore: PropTypes.func,
  children: PropTypes.node,
};

ErrorBoundary.defaultProps = {
  label: "",
  fallback: null,
  onRestore: noop,
  stopOnRestore: noop,
};

export default ErrorBoundary;
